<template>
    <Transition name="modal-fade">
        <div v-if="isVisible" class="cf-overlay" @click.self="handleBackdropClick">
            <Transition name="modal-slide">
                <div
                        v-if="isVisible"
                        class="cf-dialog cf-dialog--sm"
                        aria-modal="true"
                        role="dialog"
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                >
                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-shield-check-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title" id="modal-title">Normalisation de document</h4>
                                <p class="cf-modal-head__sub">{{ documentTypeLabel }}</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <!-- Messages -->
                        <transition name="slide-fade">
                            <div v-if="successMessage" class="cf-note norm-note--ok norm-note-mb">
                                <i class="ri-checkbox-circle-line"></i>
                                <p v-html="successMessage"></p>
                            </div>
                        </transition>

                        <transition name="slide-fade">
                            <div v-if="errorMessage" class="cf-note cf-note--danger norm-note-mb">
                                <i class="ri-error-warning-line"></i>
                                <p v-html="errorMessage"></p>
                            </div>
                        </transition>

                        <!-- Confirmation Content -->
                        <div class="norm-confirm">
                            <!-- Title -->
                            <h5 class="norm-confirm-title">
                                Confirmer la normalisation
                            </h5>

                            <!-- Description -->
                            <div class="norm-confirm-text">
                                <p id="modal-description">
                                    Vous êtes sur le point de normaliser ce document. Cette action est <span class="norm-irreversible">irréversible</span>.
                                </p>

                                <!-- Document Info -->
                                <div v-if="documentInfo" class="norm-docinfo">
                                    <div class="norm-docinfo-grid">
                                        <div class="norm-docinfo-label">Type</div>
                                        <div class="norm-docinfo-value">{{ documentInfo.type }}</div>

                                        <div v-if="documentInfo.ref" class="norm-docinfo-label">Référence</div>
                                        <div v-if="documentInfo.ref" class="norm-docinfo-value">{{ documentInfo.ref }}</div>

                                        <!--div v-if="documentInfo.date" class="norm-docinfo-label">Date de création</div>
                                        <div v-if="documentInfo.date" class="norm-docinfo-value">{{ documentInfo.date }}</div-->

                                        <div v-if="documentInfo.date" class="norm-docinfo-label">Client</div>
                                        <div v-if="documentInfo.date" class="norm-docinfo-value">{{ documentInfo.client }}</div>

                                        <div v-if="documentInfo.date" class="norm-docinfo-label">Montant</div>
                                        <div v-if="documentInfo.date" class="norm-docinfo-value">{{ documentInfo.montant }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Warning Box -->
                            <div class="cf-note cf-note--warn">
                                <i class="ri-information-line"></i>
                                <p>
                                    Cette action ne peut pas être annulée. Assurez-vous que c'est bien ce que vous voulez faire.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button
                                @click="close"
                                type="button"
                                class="ti-btn ti-btn-secondary-full"
                                :disabled="isLoading"
                        >
                            <i v-if="isLoading" class="ri-loader-4-line norm-spin"></i>
                            Annuler
                        </button>
                        <button
                                @click="confirmNormalization"
                                type="button"
                                class="ti-btn ti-btn-warning-full"
                                :disabled="isLoading"
                        >
                            <i v-if="isLoading" class="ri-loader-4-line norm-spin"></i>
                            <i v-else class="ri-shield-check-line"></i>
                            {{ isLoading ? 'Normalisation en cours...' : 'Confirmer la normalisation' }}
                        </button>
                    </div>
                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
    import { randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "NormalizationConfirmationModal",

        data() {
            return {
                isVisible: false,
                isLoading: false,
                successMessage: '',
                errorMessage: '',
                documentData: null,
                typedoc: '',
                typedocument: '',
                documentTypes: {
                    'achat': 'Achat',
                    'vente': 'Vente',
                    'frs': 'Fournisseur',
                    'clt': 'Client',
                    'NMP': 'Note de mise à prix'
                }
            };
        },

        computed: {
            documentTypeLabel() {
                return this.documentTypes[this.typedocument] || 'Document';
            },

            documentInfo() {
                if (!this.documentData) return null;

                const info = {
                    type: this.documentTypeLabel,
                    ref: this.documentData.numdoc,
                    client: this.documentData.nameclient,
                    montant: this.documentData.docmtnttotalttc,
                    date: this.documentData.creerler
                };

                // Clean up empty values
                Object.keys(info).forEach(key => {
                    if (!info[key]) delete info[key];
                });

                return Object.keys(info).length > 0 ? info : null;
            }
        },

        methods: {
            /**
             * Show the modal with document data
             */
            show(documentData, typedoc, typedocument) {
                this.resetState();
                this.documentData = documentData;
                this.typedoc = typedoc;
                this.typedocument = typedocument;
                this.isVisible = true;

                // Lock body scroll
                document.body.style.overflow = 'hidden';
            },

            /**
             * Close the modal
             */
            close() {
                if (this.isLoading) {
                    if (!confirm('La normalisation est en cours. Voulez-vous vraiment annuler ?')) {
                        return;
                    }
                }
                this.isVisible = false;
                document.body.style.overflow = '';
            },

            /**
             * Handle backdrop click
             */
            handleBackdropClick() {
                this.close();
            },

            /**
             * Reset all modal state
             */
            resetState() {
                this.isLoading = false;
                this.successMessage = '';
                this.errorMessage = '';
                this.documentData = null;
                this.typedoc = '';
                this.typedocument = '';
            },

            /**
             * Format error messages from API response
             */
            formatErrorMessage(data) {
                if (!data) return 'Une erreur est survenue';

                if (data.datamessage && Array.isArray(data.datamessage) && data.datamessage.length > 0) {
                    return data.datamessage.join('<br>');
                }

                return data.message || 'Une erreur est survenue';
            },

            /**
             * Show notification toast
             */
            showNotification(type, message, title = '') {
                // You can replace this with your preferred notification system
                const toastConfig = {
                    success: {
                        icon: '✓',
                        color: 'text-emerald-600',
                        bg: 'bg-emerald-100'
                    },
                    error: {
                        icon: '✗',
                        color: 'text-rose-600',
                        bg: 'bg-rose-100'
                    },
                    info: {
                        icon: 'ℹ',
                        color: 'text-blue-600',
                        bg: 'bg-blue-100'
                    }
                };

                const config = toastConfig[type] || toastConfig.info;
                console.log(`${type.toUpperCase()}: ${message}`);

                // In a real app, you might use a toast library
                // For now, we'll update the modal messages
                if (type === 'success') {
                    this.successMessage = message;
                } else if (type === 'error') {
                    this.errorMessage = message;
                }
            },

            /**
             * Confirm and execute normalization
             */
            async confirmNormalization() {
                if (this.isLoading) return;

                this.isLoading = true;
                this.successMessage = '';
                this.errorMessage = '';

                try {
                    // Prepare request data
                    const requestData = {
                        cf: { po: randomString() },
                        item: this.documentData,
                        document: 'NMP'
                    };

                    // Build URL
                    const url = `${process.env.VUE_APP_API_URL}/jkebfgescomporziprodpfachatventeegl745874stock771714dfe/gescom/default/vmmline/${this.typedocument}/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;

                    // Configure headers
                    const headers = {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${JwtService.getToken()}`,
                        'csrftoken': this.$store.state.appsociete
                    };

                    // Show loading state in store
                    this.$store.dispatch('lancerchargement', true);

                    // Make API call
                    const response = await axios.post(url, requestData, {
                        headers,
                        withCredentials: true
                    });

                    // Handle response
                    if (response.data.success) {
                        const successMsg = response.data.message || 'Document normalisé avec succès';

                        this.showNotification('success', successMsg);

                        // Emit success event
                        this.$emit('normalized', {
                            document: this.documentData,
                            type: this.typedocument,
                            result: response.data
                        });

                        // Auto-close after success
                        setTimeout(() => {
                            this.isVisible = false;
                            document.body.style.overflow = '';
                        }, 1500);

                    } else {
                        const errorMsg = this.formatErrorMessage(response.data);
                        this.showNotification('error', errorMsg);
                    }

                } catch (error) {
                    console.error('Normalization error:', error);

                    let errorMsg = 'Une erreur est survenue';
                    if (error.response) {
                        errorMsg = this.formatErrorMessage(error.response.data);
                    } else if (error.request) {
                        errorMsg = 'Erreur de connexion au serveur';
                    }

                    this.showNotification('error', errorMsg);

                } finally {
                    this.isLoading = false;
                    this.$store.dispatch('lancerchargement', false);
                }
            }
        },

        /**
         * Handle keyboard events
         */
        mounted() {
            /*const handleEscape = (event) => {
                if (event.key === 'Escape' && this.isVisible) {
                    this.close();
                }
            };

            window.addEventListener('keydown', handleEscape);

            // Cleanup
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('keydown', handleEscape);
                document.body.style.overflow = '';
            });*/
        },

        beforeUnmount() {
            document.body.style.overflow = '';
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : tokens uniquement (light-only) */
    .cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
    .cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
    .cf-dialog--sm { max-width:460px; }
    .cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
    .cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
    .cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
    .cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
    .cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
    .cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

    .modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
    .modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
    .modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
    .modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .slide-fade-enter-active { transition:all 0.3s ease-out; }
    .slide-fade-leave-active { transition:all 0.2s cubic-bezier(1, 0.5, 0.8, 1); }
    .slide-fade-enter-from, .slide-fade-leave-to { transform:translateY(-10px); opacity:0; }

    .cf-dialog-body .cf-note p { margin:0; }
    .norm-note-mb { margin-bottom:1rem; }
    .norm-note--ok { background:#f0fdf6; border:1px solid rgb(var(--success) / 0.35); color:#166534; }

    .norm-confirm { text-align:center; }
    .norm-confirm-title { margin:0 0 0.6rem; font-size:1rem; font-weight:700; color:var(--cf-ink-strong); }
    .norm-confirm-text { font-size:0.82rem; color:var(--cf-ink); margin-bottom:1rem; }
    .norm-confirm-text p { margin:0; }
    .norm-irreversible { font-weight:600; color:rgb(var(--warning)); }

    .norm-docinfo { margin-top:0.9rem; padding:0.7rem 0.9rem; background:var(--cf-surface); border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); text-align:left; }
    .norm-docinfo-grid { display:grid; grid-template-columns:1fr 1fr; gap:0.3rem 0.6rem; font-size:0.75rem; }
    .norm-docinfo-label { color:var(--cf-muted); }
    .norm-docinfo-value { font-weight:600; color:var(--cf-ink-strong); }

    .norm-confirm .cf-note { text-align:left; }

    .norm-spin { animation:norm-rotate 1s linear infinite; }
    @keyframes norm-rotate {
        from { transform:rotate(0deg); }
        to { transform:rotate(360deg); }
    }

    @media screen and (max-width: 768px) {
        .cf-dialog--sm { max-width:100%; }
    }
</style>
